module.exports = __webpack_public_path__ + "static/media/ScreenShot_Header_2020-06-27.9e5b3bd9.png";